import { getGeocode, getPositionList, transFormPoint } from '@dygc/request'
import { GD_KEY, SEPARATOR } from '@dygc/shared'

export default {
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      value: '',
      pois: [],
      loading: false,
      showMap: false,
      selectText: '',
      searchText: '',
      searchValue: '',
      address: {},
      allowCreate: false, // pc
      selectListFlag: false
    }
  },
  methods: {
    onClickPoi(val) {
      this.onClickSelectValue(val)
      this.setZoomAndCenter(val)
    },
    onClickSearch() {
      let text = this.searchValue
      console.log(text)
      getPositionList(text).then(res => {
        let pois = res.pois || []
        let first = pois[0]
        console.log(pois)
        this.setZoomAndCenter(first)
      })
    },
    setZoomAndCenter(item) {
      if (!item) return
      console.log(item.location)
      let [lng, lat] = item.location.split(',')
      let center = [parseFloat(lng), parseFloat(lat)]
      this.mapCase.setZoomAndCenter(20, center)
      this.address = {
        Q: lat,
        R: lng,
        add_name: item.name
      }
      this.buildMap(center, this.mapCase)
    },
    onClickFresh() {
      // console.log('fresh')
      AMap.plugin('AMap.Geolocation', this.getGeolocation)
    },
    changeIssueValue(item) {
      this.question.issue.value = item.name + '|' + item.entr_location
    },
    onClickGetPos() {
      this.showMap = true
      this.loading = true
      let scriptEl = document.createElement('script')
      scriptEl.src = `https://webapi.amap.com/maps?v=1.4.15&key=${GD_KEY}`
      document.body.appendChild(scriptEl)
      let self = this
      scriptEl.onload = function () {
        self.loadMap()
      }
    },
    getGeolocation() {
      let map = this.mapCase
      let self = this
      let geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过10秒后停止定位，默认：5s
        showMarker: false,
        showCircle: false,
        showButton: false, //定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
        convert: false
      })
      console.log(geolocation)
      map.addControl(geolocation)
      geolocation.getCurrentPosition(function (status, result) {
        if (status == 'complete') {
          self.getPosComplete(result)
        } else {
          self.getPosError(result)
        }
      })
    },
    loadMap() {
      let el = this.$refs.mapNode
      let map = (this.mapCase = new AMap.Map(el, {
        resizeEnable: true
      }))
      let self = this
      AMap.plugin('AMap.Geolocation', this.getGeolocation)
    },
    buildMap(center, map) {
      // let el = this.$refs.mapNode
      // let map = new AMap.Map(el, {
      //   resizeEnable: true,
      //   zoom: 30,
      //   center
      // })
      let marker = new AMap.Marker({
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        position: center
      })
      let circle = new AMap.Circle({
        center: new AMap.LngLat(center[0], center[1]), // 圆心位置
        radius: 100, //半径
        strokeColor: '#b3e0f2', //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线粗细度
        fillColor: 'rgb(189, 231, 245)', //填充颜色
        fillOpacity: 0.35 //填充透明度
      })
      map.add(marker)
      map.add(circle)
      map.setFitView()
    },
    getPosComplete(data) {
      this.loading = false
      let { Q, R } = data.position
      transFormPoint(R, Q)
        .then(res => {
          let [lng, lat] = res.locations.split(',')
          let center = [parseFloat(lng), parseFloat(lat)]
          this.buildMap(center, this.mapCase)
          let item = {
            Q: lat,
            R: lng
          }
          getGeocode(`${lng},${lat}`).then(data => {
            item.add_name = data.regeocode.formatted_address
            this.address = item
            // this.value= item.add_name
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    getPosError(result) {
      this.loading = false
      this.address = {
        add_name: '获取失败',
        Q: '',
        R: ''
      }
      // this.value= "获取失败"
    },
    getList(val) {
      if (this.timers) clearTimeout(this.timers)
      this.timers = setTimeout(() => {
        this.loading = true
        getPositionList(val)
          .then(res => {
            let pois = res.pois || []
            this.pois = pois.map(item => ({
              id: item.id,
              name: item.name,
              entr_location: item.location,
              location: item.location
            }))
            this.allowCreate = !pois.length
            this.question.issue.pushPoi(this.pois)
            this.loading = false
          })
          .catch(e => {
            this.loading = false
          })
        this.timers = null
      }, 200)
    }
  },
  computed: {
    allowUpdateLocation() {
      return this.question.issue.disallowUpdateLocation
    },
    allowInput() {
      return this.question.issue.disallowInput
    },
    pattern() {
      return this.question.issue.displayType
    },
    textPattern() {
      return this.pattern === 0
    },
    mapPattern() {
      return this.pattern === 1
    }
  },
  created() {
    let un = this.$watch('question.issue.value', val => {
      if (!this.textPattern) return
      if (val.includes(SEPARATOR)) {
        val = val.split(SEPARATOR)[0]
      }
      this.value = val
      un()
    })
  },
  watch: {
    value(val) {
      this.question.issue.value = val
      if (!val) {
        this.question.issue.address = {}
      }
      this.getList(val)
    },
    address(val) {
      // this.question.issue.value = val.add_name + '|' + val.R + ',' + val.Q
      this.question.issue.address = val
    }
  }
}
